import dbSchema from '@/backend/src/db/schema'

export default function canUserRead(tableName, fieldName, userPermissions) {
  try {
    const fieldSchema = dbSchema.objects
      .find((tableSchema) => tableSchema.name === tableName)
      ?.fields.find((fieldSchema) => fieldSchema.name === fieldName)

    if (typeof fieldSchema === 'undefined') return false

    if (!fieldSchema.requiresOne) return true

    return userPermissions.some((userPermission) =>
      fieldSchema.requiresOne.includes(userPermission)
    )
  } catch (error) {
    console.warn(
      `Tried to access read permissions for non-existent field ${tableName}.${fieldName}.`
    )
    throw error
  }
}
